<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>Notificações</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="py-5">
        <v-tabs v-model="tab" centered grow background-color="transparent">
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="(item, index) in tabs" :key="index" :href="`#${index + 1}`">
            <span class="tab-text">
              {{ item.name }}
              <v-badge
                class="notification-tab"
                color="red"
                top
                right
                v-if="notifications[index + 1].filter(notification => !notification.read).length > 0"
              >
              </v-badge>
            </span>
          </v-tab>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(i, index) in tabs" :key="index" :value="`${index + 1}`">
              <v-card>
                <v-container class="notification-0" v-if="!notifications[index + 1].length">
                  <v-row align-content="center" justify="center">
                    <v-col sm="12">
                      <span class="notification-0-title">Nenhuma nova notificação</span>
                    </v-col>
                  </v-row>
                </v-container>

                <div class="notification-list">
                  <ul>
                    <vue-perfect-scrollbar class="drawer-notifications--scroll" :settings="scrollSettings">
                      <li
                        v-for="(item, i) in notifications[index + 1]"
                        :key="i"
                        @click="executeNotification(item)"
                        :class="[item.entry ? 'msg-link' : 'msg-noLink']"
                      >
                        <div>{{ calculateDate(item.date) }}</div>
                        <span :class="[`${item.class}`]"></span>
                        <p :class="[!item.read && 'not-read-text']">{{ item.text }}</p>
                      </li>
                    </vue-perfect-scrollbar>
                  </ul>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import { formatEntry } from '@/helpers/utils';
import { handleLoadRoute } from '@/helpers/page';
import { sleep } from '@/helpers/page';

export default {
  components: {
    VuePerfectScrollbar: () => import('vue-perfect-scrollbar')
  },

  props: {
    dialog: { type: Boolean, default: false },
    tabIndex: { type: String, default: '1' }
  },

  data: () => ({
    scrollSettings: { maxScrollbarLength: 50, suppressScrollX: true },
    tab: null,
    tabs: [{ name: 'Alertas' }, { name: 'Eventos' }],
    dialogNotification: false
  }),

  mounted() {
    store.dispatch('notification/getAllNotificationsByUser');

    if (this.tabIndex) {
      this.tab = this.tabIndex;
    }
  },

  computed: {
    notifications: () => store.getters['notification/getNotificationByUserState']
  },

  methods: {
    handleLoadRoute,

    async close() {
      await sleep(100);
      this.$emit('handleDialog');
    },

    calculateDate: date => {
      return moment(date)
        .locale('pt-br')
        .fromNow();
    },

    async executeNotification(item) {
      const { page, mode, entry, id, type } = item;

      if ((!page && !mode) || this.notificationDisabled) {
        this.notificationDisabled = false;
        return;
      }

      await store.dispatch('notification/makeReadNotifications', { ids: [id], tab: type });

      await handleLoadRoute({
        page: page,
        mode: mode,
        redirectParams: formatEntry(entry)
      });

      this.close();
    }
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card.v-sheet,
.v-window.v-item-group {
  background-color: transparent;
  box-shadow: none;
}

.tab-text {
  position: relative;

  .notification-tab {
    position: absolute;
  }
}

.notification-list {
  padding: 10px;

  ul {
    padding: 0;
    li {
      list-style: none;
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;

      &.msg-link {
        cursor: pointer;
      }

      &.msg-noLink {
        opacity: 0.7;
      }

      div {
        font-weight: 500;
        font-size: 16px;
        width: 95px;
      }

      .not-read-text {
        font-weight: 500;
      }

      span {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 3px solid red;
        display: flex;
        margin-top: 5px;
        background-color: unset !important;
      }

      p {
        width: 77%;
        position: relative;
        padding-bottom: 0px;

        &:before {
          content: '';
          position: absolute;
          left: -29px;
          top: 26px;
          width: 3px;
          background: #e5e5e5;
          height: 100%;
        }
      }

      &:hover {
        i {
          visibility: visible;
        }
      }

      .notify-icon-close {
        visibility: hidden;
        margin-right: 30px;
        margin-top: -15px;
      }
    }
  }
}
</style>
